import React, {useState} from 'react';

interface FormScreenTriggerProps {
  label: string;
  buttonText: string; // e.g., "Select Tags" or "Choose Interests"
  onClick: () => void;
  error?: boolean;
  required?: boolean;
}

export const FormScreenTrigger: React.FC<FormScreenTriggerProps> = ({
  label,
  buttonText,
  onClick,
  error,
  required,
}) => {
  const [isHovered, setIsHovered] = useState(false);

  const containerStyle: React.CSSProperties = {
    marginBottom: '20px',
  };

  const triggerStyle: React.CSSProperties = {
    width: '100%',
    height: '46px', // Matches your FormField height
    padding: '0 16px',
    borderRadius: '8px',
    border: `1px solid ${error ? '#ff4d4d' : isHovered ? '#daff00' : '#333'}`,
    backgroundColor: isHovered ? '#333' : '#2a2a2a',
    color: isHovered ? '#daff00' : '#fff',
    fontSize: '0.85rem',
    fontWeight: 600,
    display: 'flex',
    justifyContent: 'space-between',
    alignItems: 'center',
    boxSizing: 'border-box',
    marginTop: '6px',
    cursor: 'pointer',
    transition: 'all 0.2s ease',
  };

  return (
    <div style={containerStyle}>
      <label
        style={{
          display: 'block',
          color: '#aaa',
          fontSize: '0.77rem',
          fontWeight: 600,
          textTransform: 'uppercase',
          letterSpacing: '0.5px',
        }}>
        {label} {required && <span style={{color: '#daff00'}}>*</span>}
      </label>

      <div
        style={triggerStyle}
        onClick={onClick}
        onMouseEnter={() => setIsHovered(true)}
        onMouseLeave={() => setIsHovered(false)}>
        <span>{buttonText}</span>
        <span
          style={{
            fontSize: '1.3rem',
            transform: isHovered ? 'translateX(5px)' : 'translateX(0)',
            transition: 'transform 0.2s ease',
          }}>
          →
        </span>
      </div>

      {error && (
        <span
          style={{
            color: '#ff4d4d',
            fontSize: '0.8rem',
            marginTop: '6px',
            display: 'block',
            fontWeight: 500,
          }}>
          Selection required
        </span>
      )}
    </div>
  );
};
